import { render, staticRenderFns } from "./evidencia-profesiograma-editar.vue?vue&type=template&id=20587ef0&scoped=true&"
import script from "./evidencia-profesiograma-editar.vue?vue&type=script&lang=js&"
export * from "./evidencia-profesiograma-editar.vue?vue&type=script&lang=js&"
import style0 from "./evidencia-profesiograma-editar.vue?vue&type=style&index=0&id=20587ef0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20587ef0",
  null
  
)

export default component.exports